/*
 *
 * CommerceWebTenantPopup
 *
 */
import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import PortalSelect from '@nexidigital/portalselect'
import Toggle from 'Hoc/ToggleComponent'
import formattedMessage from './languageModule'
import './CommerceWebTenantPopup.scss'

const TENANT = 'tenant'
const DEFAULT_TENANTS = ['isp', 'nexid']

const getTenantLabel = (intl, value) => {
  switch (value) {
    case 'isp':
      return intl.formatMessage(formattedMessage.ispOption.props)
    case 'nexid':
      return intl.formatMessage(formattedMessage.nexiDirectOption.props)
    default:
      return value
  }
}

const CommerceWebTenantPopup = (props) => {
  const [tenant, setTenant] = useState('')
  const [showError, setShowError] = useState(false)
  const intl = useIntl()
  const tenantOptions = useMemo(() => props.tenants.map(value => ({
    label: getTenantLabel(intl, value),
    value
  })), [intl, props.tenants])

  const handleTenantChange = (event) => {
    setTenant(event.value)
    setShowError(false)
  }

  const handlePrimaryAction = () => {
    if (!tenant) {
      setShowError(true)
      return
    }

    props.actions.doGetUrlForCommerceWeb({
      flow: props.flow,
      tenant,
      widget: props.widget
    })
    props.actions.doHidePopup()
  }

  return (
    <Toggle>
      <MerchantModal
        ariaModalDescription=''
        ariaModalTitle=''
        onClose={() => props.actions.doHidePopup()}
        primaryAction={handlePrimaryAction}
        primaryButtonLabel={formattedMessage.continue}
        primaryButtonLoading={props.isLoading}
        title={formattedMessage.title}
        customAnalyticsDescription={formattedMessage.description}
      >
        <MerchantGenericCard title={<span className='commerceWebTenantPopupCardTitle'>{formattedMessage.description}</span>}>
          <div className='commerceWebTenantPopup'>
            <PortalSelect
              noSearch
              id={TENANT}
              name={TENANT}
              label={formattedMessage.selectLabel}
              placeholder={intl.formatMessage(formattedMessage.placeholder.props)}
              options={tenantOptions}
              value={tenant}
              error={showError}
              errorText={showError ? formattedMessage.requiredError : ''}
              onChange={handleTenantChange}
            />
          </div>
        </MerchantGenericCard>
      </MerchantModal>
    </Toggle>
  )
}

CommerceWebTenantPopup.propTypes = {
  actions: PropTypes.object,
  flow: PropTypes.string,
  tenants: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  widget: PropTypes.object
}

CommerceWebTenantPopup.defaultProps = {
  actions: {},
  tenants: DEFAULT_TENANTS,
  isLoading: false,
  widget: null
}

export default CommerceWebTenantPopup
